import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
// import OrderActions from "./OrderActions"; // Uncomment if needed

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const MultiLineText = styled("div")(() => ({
  whiteSpace: "normal",
  lineHeight: 1.4,
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
}));

interface TableItemProps {
  customer: CustomerMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ customer }) => {
  // Optional: format date (if ISO string)
  const formattedDate = customer.created_date
    ? new Date(customer.created_date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    : "-";

  const fields: (string | undefined)[] = [
    formattedDate,
    customer.contact_name,
    customer.contact_number,
    customer.contact_email,
    customer.state,
    customer.city,
    customer.area,
    customer.reference,
    customer.address,

  ];

  return (
    <TableRow className="item-hover">
      {/* Uncomment if you want action buttons:
      <TableCell align="left" sx={commonCellStyle}>
        <OrderActions data={customer} />
      </TableCell>
      */}

      {fields.map((field, index) => (
        <TableCell key={index} align="left" sx={commonCellStyle}>
          <MultiLineText>{field || "-"}</MultiLineText>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableItem;
